import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CategoryCard } from '../../Shared';
import { TrendBadge } from '../styles';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

/**
 * GovernanceOverview - High-level governance structure for public view
 * Shows category cards without drill-down capability
 * @param {Array} categories - Array of governance categories
 * @param {object} overallPosture - Overall posture with trend indicator
 */
export const GovernanceOverview = ({ categories = [], overallPosture }) => {
  const { t } = useTranslation('transparency');
  const isPositiveTrend = overallPosture?.trend === 'improving' || overallPosture?.trend === 'stable';

  return (
    <Box>
      {overallPosture && (
        <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
          <TrendBadge positive={isPositiveTrend}>
            {isPositiveTrend ? (
              <TrendingUpIcon fontSize="small" />
            ) : (
              <TrendingFlatIcon fontSize="small" />
            )}
            {overallPosture.label || t('public.defaultPostureLabel')}
          </TrendBadge>
          {overallPosture.description && (
            <Typography variant="body2" color="text.secondary">
              {overallPosture.description}
            </Typography>
          )}
        </Box>
      )}

      {categories && categories.length > 0 ? (
        <Grid container spacing={2}>
          {categories.map((category, index) => (
            <Grid item xs={12} sm={6} md={4} key={category.id || index}>
              <CategoryCard
                name={category.name}
                description={category.description}
                maturityLabel={category.maturityLabel}
                statusLabel={category.statusLabel}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography variant="body2" color="text.secondary">
          {t('public.governanceUnavailable')}
        </Typography>
      )}
    </Box>
  );
};
